import { Clock, Award, ShieldCheck, Zap, Users, MapPin } from "lucide-react";
import { trackEvent } from "@/utils/tracking";

const STATS = [
  { id: "same-day", icon: Clock, number: "Same Day", label: "Service Available", small: true },
  { id: "rating", icon: Award, number: "5.0", label: "Stars on Google (89+ Reviews)" },
  { id: "licensed", icon: ShieldCheck, number: "Licensed", label: "& Fully Insured", small: "xs" },
  { id: "projects", icon: Zap, number: "500+", label: "Luxury Projects Completed" },
  { id: "satisfaction", icon: Users, number: "100%", label: "Client Satisfaction" },
  { id: "location", icon: MapPin, number: "SWFL", label: "Naples to Cape Coral & Beyond" },
];

const STAT_SIZE_CLASSES = {
  xs: "text-base sm:text-lg md:text-2xl",
  sm: "text-lg sm:text-xl md:text-2xl",
  default: "text-2xl md:text-3xl",
};

function statSizeClass(small) {
  if (small === "xs") return STAT_SIZE_CLASSES.xs;
  if (small) return STAT_SIZE_CLASSES.sm;
  return STAT_SIZE_CLASSES.default;
}

export default function WhyChooseUs() {
  return (
    <section id="why-us" data-testid="why-us-section" className="py-24 md:py-32 bg-[#0A111C]" aria-label="Why Choose Us">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          <div className="lg:sticky lg:top-32">
            <p className="text-xs font-bold tracking-[0.2em] uppercase text-blue-400 mb-4">
              Why Choose Us
            </p>
            <h2
              className="text-3xl md:text-4xl tracking-tight font-medium mb-6"
              style={{ fontFamily: 'Outfit, sans-serif' }}
            >
              Built for Luxury,
              <br />
              Backed by Excellence
            </h2>
            <p className="text-slate-400 text-lg leading-relaxed mb-4">
              We're not a big-box store add-on. I.T. Help of SWFL delivers white-glove technology 
              services for Naples' most prestigious addresses — from Port Royal estates and Pelican Bay 
              condos to waterfront properties on Marco Island.
            </p>
            <p className="text-slate-400 text-lg leading-relaxed mb-8">
              Our background-checked technicians work with custom builders, interior designers, 
              and property managers. We integrate UniFi, Sonos, Honeywell, and Ring systems
              with the same precision as the craftsmen who built your home.
            </p>
            <div className="flex gap-4">
              <a
                href="#contact"
                data-testid="why-us-cta"
                onClick={() => trackEvent("consultation_click", { location: "why-us" })}
                className="bg-blue-600 text-white hover:bg-blue-700 font-medium px-6 py-3 rounded-lg transition-all btn-glow text-sm"
              >
                Get a Free Consultation
              </a>
              <a
                href="tel:2398344377"
                data-testid="why-us-call-btn"
                onClick={() => trackEvent("call_click", { location: "why-us" })}
                className="border border-white/20 hover:border-white/40 hover:bg-white/5 text-white font-medium px-6 py-3 rounded-lg transition-all text-sm"
              >
                Call Us Now
              </a>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            {STATS.map((stat) => {
              const Icon = stat.icon;
              return (
                <div
                  key={stat.id}
                  data-testid={`stat-card-${stat.id}`}
                  className="glass-card glass-card-hover p-5 md:p-6"
                >
                  <div className="w-10 h-10 rounded-lg bg-blue-600/15 flex items-center justify-center mb-4">
                    <Icon size={20} className="text-blue-400" />
                  </div>
                  <div className={`stat-number ${statSizeClass(stat.small)} mb-1`}>{stat.number}</div>
                  <div className="stat-label text-xs md:text-sm">{stat.label}</div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
